module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    staticClass: "align-self-stretch pb-5",
    attrs: {
      "xs12": ""
    }
  }, [(_vm.tab !== 5) ? _c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Panou de control")]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.tab === 1) ? _c('tud-users-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 2) ? _c('tud-addresses-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 3) ? _c('tud-requests-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 4) ? _c('tud-statuses-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), (_vm.tab === 5) ? _c('tud-map-card-users') : _vm._e(), _vm._v(" "), (_vm.tab === 6) ? _c('tud-map-card-addr') : _vm._e(), _vm._v(" "), (_vm.tab === 7) ? _c('tud-archives-card', {
    attrs: {
      "display": _vm.display
    }
  }) : _vm._e(), _vm._v(" "), _c('v-bottom-nav', {
    staticClass: "primary",
    attrs: {
      "shift": "",
      "value": "true"
    }
  }, [_c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 1
    },
    on: {
      "click": function($event) {
        _vm.tab = 1
      }
    }
  }, [_c('span', [_vm._v("Utilizatori")]), _vm._v(" "), _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 2
    },
    on: {
      "click": function($event) {
        _vm.tab = 2
      }
    }
  }, [_c('span', [_vm._v("Adrese")]), _vm._v(" "), _c('v-icon', [_vm._v("location_on")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 3
    },
    on: {
      "click": function($event) {
        _vm.tab = 3
      }
    }
  }, [_c('span', [_vm._v("Cereri de access")]), _vm._v(" "), _c('v-icon', [_vm._v("lock")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 4
    },
    on: {
      "click": function($event) {
        _vm.tab = 4
      }
    }
  }, [_c('span', [_vm._v("Satus utilizatori")]), _vm._v(" "), _c('v-icon', [_vm._v("person_pin")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 5
    },
    on: {
      "click": function($event) {
        _vm.tab = 5
      }
    }
  }, [_c('span', [_vm._v("Useri")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 6
    },
    on: {
      "click": function($event) {
        _vm.tab = 6
      }
    }
  }, [_c('span', [_vm._v("Adrese")]), _vm._v(" "), _c('v-icon', [_vm._v("map")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "white--text",
    attrs: {
      "value": _vm.tab === 7
    },
    on: {
      "click": function($event) {
        _vm.tab = 7
      }
    }
  }, [_c('span', [_vm._v("Arhive")]), _vm._v(" "), _c('v-icon', [_vm._v("file_download")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a3468c5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Dashboard.vue
// module id = 599
// module chunks = 12